import React from 'react'

import cover from './cover-1.png'

class App extends React.Component {
  render() {
    const containerStyle = {
      width: '100vw',
      height: '100vh',
      backgroundImage: `url(${cover})`,
      backgroundSize: '100%',
      backgroundRepeat: 'no-repeat',
    }
    const headerStyle = {
      paddingTop: '55vh',
      textAlign: 'center',
      color: 'white',
      textShadow: '0 0 8px black',
      fontFamily: `'Reem Kufi', sans-serif`,
    }
    const h1style = {
      fontFamily: `'Megrim', sans-serif`,
      fontSize: '42pt',
    }
    const h2style = {
    }
    return (
      <div style={containerStyle}>
        <header style={headerStyle}>
          <h1 style={h1style}>vurch</h1>
          <h2 style={h2style}>the future of faith</h2>
          <p><i>coming soon</i></p>
        </header>
      </div>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js